import { endpoints } from 'services/endpoints';
import request from 'services/request';
import { paramsToFormData } from 'utils/utils';

export default {
  postMailingList: (params: MailingListReqDto): Promise<MailingListResDto> =>
    request({
      url: endpoints.mailing.list,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postMailingAdd: (params: MailingSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.mailing.add,
      method: 'post',
      data: paramsToFormData(params),
    }),
};
